import React from 'react';
import { Percent, Users, Globe } from 'lucide-react';

const TaxParametersSection = ({ 
  formData, 
  handleInputChange, 
  errors,
  taxResidencyTypes
}) => {
  return (
    <div className="mb-6 bg-blue-50 dark:bg-blue-900/20 p-4 rounded-lg border border-blue-200 dark:border-blue-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Percent className="w-5 h-5 mr-2 text-blue-500" />
        Налоговые параметры
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Налоговый статус */}
        <div>
          <label htmlFor="taxResidency" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Users className="w-4 h-4 mr-2 text-blue-500" />
            Налоговый статус
          </label>
          <select
            id="taxResidency"
            name="taxResidency"
            value={formData.taxResidency}
            onChange={handleInputChange}
            className={`form-select w-full ${errors.taxResidency ? 'input-error' : ''}`}
          >
            {taxResidencyTypes.map((type) => (
              <option key={type.id} value={type.id}>
                {type.name}
              </option>
            ))}
          </select>
          {errors.taxResidency && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.taxResidency}
            </p>
          )}
        </div>

        {/* Ставка НДФЛ */}
        <div>
          <label htmlFor="taxRate" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Percent className="w-4 h-4 mr-2 text-blue-500" />
            Ставка НДФЛ (%)
          </label>
          <input
            type="text"
            id="taxRate"
            name="taxRate"
            value={formData.taxRate}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.taxRate ? 'input-error' : ''}`}
            placeholder="Введите ставку"
          />
          {errors.taxRate && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.taxRate}
            </p>
          )}
        </div>

        {/* Соглашение об избежании двойного налогообложения */}
        <div className="col-span-full">
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="hasDoubleTaxTreaty"
              checked={formData.hasDoubleTaxTreaty}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Применить соглашение об избежании двойного налогообложения
            </span>
          </label>
        </div>

        {/* Ставка налога источника (отображается только если есть соглашение) */}
        {formData.hasDoubleTaxTreaty && (
          <div className="col-span-full">
            <label htmlFor="foreignWithholdingTax" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
              <Globe className="w-4 h-4 mr-2 text-blue-500" />
              Ставка налога, удерживаемого у источника (%)
            </label>
            <input
              type="text"
              id="foreignWithholdingTax"
              name="foreignWithholdingTax"
              value={formData.foreignWithholdingTax}
              onChange={handleInputChange}
              className={`form-input w-full ${errors.foreignWithholdingTax ? 'input-error' : ''}`}
              placeholder="Введите ставку"
            />
            {errors.foreignWithholdingTax && (
              <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                {errors.foreignWithholdingTax}
              </p>
            )}
            <p className="mt-2 text-xs text-blue-600 dark:text-blue-400">
              Это налог, который удерживается в стране источника дивидендов. 
              Для российских акций обычно это 13%, для американских - 10%, 
              для акций других стран ставка может варьироваться в зависимости от условий соглашения.
            </p>
          </div>
        )}
      </div>

      <div className="mt-4 bg-blue-100 dark:bg-blue-900/30 p-3 rounded-lg">
        <h4 className="text-sm font-medium text-blue-700 dark:text-blue-300 mb-1">Важно знать о налогообложении дивидендов</h4>
        <p className="text-xs text-blue-600 dark:text-blue-400">
          С 2021 года в России дивиденды облагаются НДФЛ по ставке 13% для резидентов и 15% для нерезидентов. 
          При получении дивидендов от иностранных компаний может применяться соглашение об избежании двойного налогообложения, 
          позволяющее учесть налог, уже уплаченный за рубежом.
        </p>
      </div>
    </div>
  );
};

export default TaxParametersSection;